import React from 'react';
import ThongTinYeuCauKiemTraDeXuat from './ThongTinYeuCauKiemTraDeXuat.jsx';
import { Text, TextMessage } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { Link, browserHistory } from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';

class KetQuaCanBoKiemTraDeXuat extends React.Component {

  onClickClose() {
    if (typeof this.props.handleBack == 'function') {
      this.props.handleBack();
    } else {
      browserHistory.goBack();
    }
  }

  componentDidMount() {
    if (window.debug) {
      console.log('giai-quyet-don/subView/KetQuaCanBoKiemTraDeXuat');
    }
  }

  render() {
    return (
      <section className="wrap-block">
        <ThongTinYeuCauKiemTraDeXuat listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon} {...this.props.dataKiemTraDeXuat}
          hideTable={true} donInfo={this.props.donInfo} />
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className="title-14 mb15">Báo cáo kết quả kiểm tra</h2>
        <form className="form-action">
          <div className="row pl10 pr10">
            <Text value={this.props.thongTinYeuCauKiemTraDeXuat.yKienXuLy ? this.props.thongTinYeuCauKiemTraDeXuat.yKienXuLy : ''} className="areal-wrap col-100" label="Ý kiến xử lý:"/>
            <div className="col-100 pb5">
              <ContainerFileDinhKem name="BaoCaoKQKT" label="Danh sách văn bản xử lý" hideDescription={true} disableAttachFile={true} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon}/>
            </div>
          </div>
          <ShowIf condition={!this.props.boSungThongTin && (this.props.noiDungBoSungHoSo != '' && this.props.noiDungBoSungHoSo != null)}>
            <div className="col-100 no-gutter">
              <div className="wrap-big-line pt5 pb15">
                <span className="big-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(this.props.noiDungBoSungHoSo)}/>
                  </div>
                </div>
              </div>
              <div className="col-100 pb5 no-gutter">
                <ContainerFileDinhKem name="BoSungTT" label="Danh sách văn bản bổ sung" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
              </div>
            </div>
          </ShowIf>
          <ShowIf condition={!this.props.boSungThongTin}>
            <div className="box-bottom">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            </div>
          </ShowIf>
        </form>
      </section>
    );
  }
}

KetQuaCanBoKiemTraDeXuat.defaultProps = {
  listTaiLieuVanThuBoSungHoSo: [],
  boSungThongTin: false,
  validators: {}
}

export default KetQuaCanBoKiemTraDeXuat;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/KetQuaCanBoKiemTraDeXuat.jsx